import { ProductType } from '../types/ProductType';

export type ProductCapabilities = {
  maxSlidesPerGroup: number;
  allowSensorConfiguration: boolean;
};

export const productConfigs: Record<ProductType, ProductCapabilities> = {
  Generic: {
    maxSlidesPerGroup: Infinity,
    allowSensorConfiguration: true,
  },
  TrihowPad: {
    maxSlidesPerGroup: 4,
    allowSensorConfiguration: false,
  },
};
